export { DoctorLinkTable } from './linked-link-table';
export { DoctorLinkReceivedTable } from './received-link-table';
export { DoctorLinkSentTable } from './sent-link-table';
